import styled from 'styled-components';

export const AllCategoriesContainer = styled.div`
  background-color: #f8f8f8;
  display: flex;
  flex-direction: row;
  justify-content: center;
  height: 100%;
  overflow: hidden;
  padding-top: 32px;
  margin-bottom: 40px;
`;

export const SidebarContainer = styled.div`
  width: 23%;
  height: 87vh;
  background-color: white;
  padding-bottom: 40px;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Sidebar = styled.div`
  .itemContainer {
    background-color: #fff;
    padding: 16px 5px;
  }

  .singleContainer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 10px 0px;
    font-family: Montserrat;
    text-align: center;
    color: rgba(0, 0, 0, 0.6);
    font-size: 12px;
    &.selected {
      color: #ef4e5e;
      font-weight: bold;
    }

    img {
      border-radius: 8px;
    }

    p {
      margin: 12px 4px;
    }
  }
`;

export const EachCategoryContainer = styled.div`  
    width: 75%;
    height: 87vh;
    overflow-y: auto;
    border-radius: 8px;
    margin: 0 5px;

    .topBanner{
            border-radius: 12px;
    }
    ${(props) =>
      props.isAnimating &&
      `
        animation: reverseScroll 0.3s linear;
        @keyframes reverseScroll {
            0% {
                transform: translateY(100%);
            }
            100% {
                transform: translateY(0%);
            }
        }
    `}

    &::-webkit-scrollbar {
        display: none;
    }

    .productCategoryContainer {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 8px;
    }

    .productCategoryCard{
        display: flex;
        flex-direction: column;
        flex-grow: 0;
        padding: 8px 8px 9px;
        border-radius: 8px;
        background-color: #fff;
        font-family: Montserrat;

        .productHeading{
            font-size: 14px;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.87);
            margin: 8px 0;
        }

        .imageWithText{
            display: flex;
            flex-direction: row;
            align-items: center;
            
            img{
                margin-right: 8px;
            }
        }

        p{
            font-size: 10px;
            color: rgba(0, 0, 0, 0.6);
        }
    }

    .trendingHeading{
        font-family: Montserrat;
        font-size: 20px;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.87);
        margin: 30px 0;
    }

    .trendingProducts{
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        font-family: Montserrat;
        font-size: 14px;
        font-weight: 800;
        gap: 0px;
    }  

    .GoToNextCategory{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        margin: 25px 0 120px 0;

        button{
            background-color: #ef4e5e;
            color: #fff;
            border: none;
            border-radius: 20px;
            padding: 8px 20px;
            font-family: Montserrat;
            font-size: 14px;
            font-weight: 600;
            cursor: pointer;

        &.shakeanimation {
            animation: shakeButton 1s linear;

            @keyframes shakeButton {
                10%,
                90% {
                    transform: translate3d(-1px, 0, 0);
                }

                20%,
                80% {
                    transform: translate3d(2px, 0, 0);
                }

                30%,
                50%,
                70% {
                    transform: translate3d(-4px, 0, 0);
                }

                40%,
                60% {
                    transform: translate3d(4px, 0, 0);
                }
            }
        }
    }
`;
